module.exports = __webpack_public_path__ + "static/media/spotify.e76751ef.svg";